import { createWebHistory, createRouter } from 'vue-router';
import pathLoader from '../plugins/loader'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: pathLoader('home'),
  },
  {
    path: '/cart',
    name: 'Cart',
    component: pathLoader('cart'),
  },
  {
    path: '/success',
    name: 'Success',
    component: pathLoader('success'),
  },
  {
    path: '/verifier-ticket',
    name: 'Verification',
    component: pathLoader('verification'),
  },
  {
    path: '/speakers',
    name: 'Speakers',
    component: pathLoader('speakers'),
  },
  {
    path: '/become-speaker',
    name: 'BecomeSpeaker',
    component: pathLoader('become-speaker'),
  },
  {
    path: '/calendrier',
    name: 'Calendrier',
    component: pathLoader('calendrier'),
  },
  {
    path: '/submit-presentation',
    name: 'SubmitPresentation',
    component: pathLoader('submit-presentation'),
  },
  {
    path: '/partners',
    name: 'Partners',
    component: pathLoader('partners'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
